"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { cn } from "@repo/ui/utils";
import { NavButton } from "@repo/ui/nav-button";
import { ApartmentCardSingle } from "@/components/cards/apartment-card";
import { getI18nString } from "@/lib/utils";
import { ApartmentListingHeader } from "./apartment-listing-header.component";
import type { ApartmentListingOneCardProps } from "./apartment-listing.types";
export function ApartmentListingOneCard(t0) {
  const $ = _c(20);
  const {
    sectionHeader,
    apartments,
    className
  } = t0;
  const [activeIndex, setActiveIndex] = useState(0);
  if (apartments.length === 0) {
    return null;
  }
  const activeApartment = apartments[activeIndex];
  let t1;
  if ($[0] !== className) {
    t1 = cn("bg-surface-light", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== sectionHeader) {
    t2 = <div className="col-span-full tablet:col-span-4"><ApartmentListingHeader {...sectionHeader} /></div>;
    $[2] = sectionHeader;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeIndex || $[5] !== apartments) {
    t3 = apartments.length > 1 && <div className="flex flex-row items-center gap-2 overflow-x-auto" role="tablist" aria-label="Apartment types">{apartments.map((apt, index) => <NavButton key={apt._id} variant="item" active={index === activeIndex} role="tab" aria-selected={index === activeIndex} aria-controls="apartment-card-panel" onClick={() => setActiveIndex(index)}>{getI18nString(apt.apartmentListingContent?.headline)}</NavButton>)}</div>;
    $[4] = activeIndex;
    $[5] = apartments;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeApartment) {
    t4 = activeApartment && <ApartmentCardSingle apartment={activeApartment} />;
    $[7] = activeApartment;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div id="apartment-card-panel" role="tabpanel">{t4}</div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <div className="col-span-full tablet:col-span-7 tablet:col-start-6 flex flex-col gap-6 tablet:gap-8">{t3}{t5}</div>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t2 || $[15] !== t6) {
    t7 = <div className="container-grid py-16 desktop:py-28"><div className="col-span-full grid grid-cols-subgrid gap-y-8 tablet:gap-y-12">{t2}{t6}</div></div>;
    $[14] = t2;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t1 || $[18] !== t7) {
    t8 = <section className={t1} data-testid="apartment-listing-one-card">{t7}</section>;
    $[17] = t1;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}